<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        style="display: flex; justify-content: space-between; align-items: center;"
      >
        <v-btn color="primary" class="ml-2 white--text" @click="addNew">
          <v-icon dark>mdi-plus</v-icon> añadir
        </v-btn>
      </v-col>
    </v-row>
    <v-row :justify="'center'">
      <v-col cols="12" sm="12" md="12">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-data-table
            :headers="headers"
            :items="posContactData"
            class="elevation-1"
            :hide-default-footer="true"
          >
            <template v-slot:item.contact="{ item }">
              <v-text-field
                class="mt-4"
                v-model="editedItem.contact"
                dense
                single-line
                v-if="item.rowKey === editedItem?.rowKey"
                required
                :rules="requiredRules"
              ></v-text-field>
              <span v-else>{{ item.contact }}</span>
            </template>
            <template v-slot:item.workPosition="{ item }">
              <v-select
                class="mt-4"
                v-model="editedItem.workPosition"
                :items="workPositionOptions"
                placeholder="Seleccionar cargo"
                dense
                single-line
                v-if="item.rowKey === editedItem?.rowKey"
                required
                :rules="requiredRules"
              ></v-select>
              <span v-else>{{ item.workPosition }}</span>
            </template>
            <template v-slot:item.email="{ item }">
              <v-text-field
                class="mt-4"
                v-model="editedItem.email"
                dense
                single-line
                v-if="item.rowKey === editedItem?.rowKey"
              ></v-text-field>
              <span v-else>{{ item.email }}</span>
            </template>
            <template v-slot:item.phone="{ item }">
              <v-text-field
                class="mt-4"
                v-model="editedItem.phone"
                dense
                single-line
                v-if="item.rowKey === editedItem?.rowKey"
              ></v-text-field>
              <span v-else>{{ item.phone }}</span>
            </template>
            <template v-slot:item.phone2="{ item }">
              <v-text-field
                class="mt-4"
                v-model="editedItem.phone2"
                dense
                single-line
                v-if="item.rowKey === editedItem?.rowKey"
              ></v-text-field>
              <span v-else>{{ item.phone2 }}</span>
            </template>
            <template v-slot:item.colaboration="{ item }">
              <v-text-field
                class="mt-4"
                v-model="editedItem.colaboration"
                type="number"
                dense
                single-line
                v-if="item.rowKey === editedItem?.rowKey"
                required
                :rules="requiredRulesCollaboration"
              ></v-text-field>
              <span v-else>{{ item.colaboration }}</span>
            </template>
            <template v-slot:item.color="{ item }">
              <v-select
                class="mt-4"
                dense
                single-line
                v-model="editedItem.color"
                :items="colorOptions"
                v-if="item.rowKey === editedItem?.rowKey"
              ></v-select>
              <span v-else>{{ item.color }}</span>
            </template>
            <template v-slot:header.color>
              <span>Color</span>
              <v-tooltip bottom open-on-click max-width="360">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="ml-1 mt-n3"
                    small
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <div>
                  <div>1. Que funcione/que me aporte negocio/lo quiero ya/ ROJO</div>
                  <div>2. Que esté todo claro / números / planificación/ AZUL</div>
                  <div>3. Que haya confianza / que no me genere problemas/ VERDE</div>
                  <div>4. Que me aporte algo diferente / imagen / exclusividad/ AMARILLO</div>
                </div>
              </v-tooltip>
            </template>
            <template v-slot:item.actions="{ item }">
              <div v-if="item.rowKey === editedItem?.rowKey">
                <v-icon color="red" class="mr-3" @click="close">
                  mdi-window-close
                </v-icon>
                <v-icon color="green" @click="save">
                  mdi-content-save
                </v-icon>
              </div>
              <div v-else>
                <v-icon color="green" class="mr-3" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
                <v-icon color="red" @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </div>
            </template>
            <template v-slot:no-data>
              Empty
            </template>
          </v-data-table>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";
import _ from "lodash";

export default {
  name: "contactPersonTable",
  props: ["posData", "updatePosContacts", "apiGetBrandsUrl"],
  data: function() {
    return {
      posContactData: [],
      editedIndex: -1,
      editedItem: null,
      defaultItem: {
        id: null,
        rowKey: null,
        posId: null,
        contact: null,
        workPosition: null,
        email: null,
        phone: null,
        phone2: null,
        colaboration: null,
        color: null,
        brands: [],
        brandIds: []
      },
      colorOptions: ["ROJO", "AZUL", "VERDE", "AMARILLO"],
      workPositionOptions: [
        "Único responsable",
        "Operacional /Gerente",
        "Responsable de Congelado",
        "Responsable de Refrigerado",
        "Responsable de Seco",
        "Responsable de Parafarmacia/Bazar",
        "Reponedor de Congelado",
        "Reponedor de Refrigerado",
        "Reponedor de Seco",
        "Reponedor de Parafarmacia/Bazar",
        "Diana Merchand"
      ],
      valid: true,
      requiredRules: [v => !!v || "Required"],
      requiredRulesCollaboration: [
        v => !!v || "Required",
        v =>
          !v ||
          (parseInt(v) >= 0 && parseInt(v) <= 10) ||
          "Esto debería ser de 0 a 10."
      ],
      requiredRulesPhone2: [
        v => !!v || "Required",
        v =>
          !v ||
          /^([01]\d|2[0-3]):([0-5]\d)\s*\/\s*([01]\d|2[0-3]):([0-5]\d)$/.test(
            v
          ) ||
          "Esto debería ser HH:mm / HH:mm."
      ],
      requiredRulesPhone: [
        v => !!v || "Required",
        v =>
          !v ||
          /^\d{9}$/.test(v) ||
          "El número de teléfono debe tener 9 dígitos.."
      ],
      emailRules: [
        v => !!v || "El campo de email es obligatorio",
        v =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "El email proporcionado debe ser una dirección de email válida"
      ]
    };
  },
  watch: {
    async posData(newVal, oldVal) {
      if (newVal) {
        this.init(newVal);
      }
    }
  },
  computed: {
    headers() {
      return [
        {
          text: `${this.$t("contact_person")}`,
          value: "contact",
          sortable: false,
          width: 150
        },
        {
          text: `${this.$t("workPosition")}`,
          value: "workPosition",
          sortable: false,
          width: 150
        },
        {
          text: `${this.$t("salesforce.email")}`,
          value: "email",
          sortable: false,
          width: 150
        },
        {
          text: `${this.$t("phone")}`,
          value: "phone",
          sortable: false,
          width: 150
        },
        {
          text: `${this.$t("call_schedule")}`,
          value: "phone2",
          sortable: false,
          width: 150
        },
        {
          text: "Color",
          value: "color",
          sortable: false,
          width: 120
        },
        {
          text: `${this.$t("colaboration")}`,
          value: "colaboration",
          sortable: false,
          width: 150
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: 150
        }
      ];
    },
  },
  methods: {
    addNew() {
      const addObj = Object.assign({}, this.defaultItem);
      if (this.posContactData.length > 0) {
        addObj.rowKey =
          parseInt(this.posContactData[this.posContactData.length - 1].rowKey) +
          1;
      } else {
        addObj.rowKey = this.posContactData.length + 1;
      }
      if (this.posContactData.length > 0) {
        let lastItem = null;
        lastItem = this.posContactData[this.posContactData.length - 1];
        if (!lastItem?.id) {
          return;
        }
      }
      this.posContactData.push(addObj);
      this.editItem(addObj);
    },
    async editItem(item) {
      this.editedIndex = this.posContactData.indexOf(item);
      this.editedItem = item;
    },
    async deleteItem(item) {
      const index = this.posContactData.indexOf(item);
      let posContactId = this.posContactData[index].id;
      if (posContactId) {
        await ApiService.delete(`pos/delete_pos_contacts/${posContactId}`);
      }
      this.posContactData.splice(index, 1);
      this.updatePosContacts(this.posContactData);
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    async save() {
      let updatedPosContactData = this.posContactData[this.editedIndex];
      if (this.$refs.form.validate()) {
        if (this.posData && this.posData?.id) {
          let postData = {
            posId: this.posData.id,
            updatedPosContactData
          };
          let { contactItem } = await ApiService.post(
            "pos/save_pos_contacts",
            postData
          );
          this.editedItem = contactItem;
          if (this.editedIndex > -1) {
            this.posContactData[this.editedIndex] = this.editedItem;
          }
          this.updatePosContacts(this.posContactData);
          this.close();
        } else {
          if (this.editedIndex > -1) {
            this.posContactData[this.editedIndex] = this.editedItem;
          }
          this.updatePosContacts(this.posContactData);
          this.close();
        }
      }
    },
    async checkSelectedAllBrands(pos_contacts) {
      try {
        let { pos_contact_data } = await ApiService.post(
          `pos/checkSelectedAllBrands`,
          {
            posContactData: pos_contacts
          }
        );
        return pos_contact_data;
      } catch (error) {
        return [];
      }
    },
    async init(posData) {
      if (posData && posData?.pos_contacts) {
        this.posContactData = await this.checkSelectedAllBrands(
          posData.pos_contacts
        );
        this.posContactData = this.posContactData.map((el, index) => {
          let pushItem = { ...el };
          pushItem.rowKey = index + 1;
          pushItem.brandIds = pushItem.brands.map(bEl => bEl.id);
          return pushItem;
        });
        this.defaultItem.posId = this.posData.id;
      } else {
        this.posContactData = [];
        this.defaultItem.posId = this.posData.id;
      }
    }
  },
  async updated() {},
  async mounted() {
    this.init(this.posData);
  }
};
</script>

<style></style>
